import type { Observable } from 'rxjs';
import type { CollectionQueryStateStatuses } from '@common/adapters/collection-query';
import type { ChatBotChainEntity } from '@common/types/chat-bot-chain.type';
import type { ChatBotChainsCollectionState } from './chat-bot-chains.reducer';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { mergeMap, of } from 'rxjs';

import ChatBotChainsActions from './chat-bot-chains.actions';
import * as ChatBotChainsSelectors from './chat-bot-chains.selectors';

@Injectable()
export class ChatBotChainsCollectionFacade {
    private readonly store = inject<Store<ChatBotChainsCollectionState>>(Store);

    public loadChatBotChainsCollection(messenger: string, chatBotId: string): void {
        this.store.dispatch(ChatBotChainsActions.loadCollectionRequest({ messenger, chatBotId }));
    }

    public chatBotChains$(messenger: string, chatBotId: string): Observable<ChatBotChainEntity[]> {
        if (!messenger || !chatBotId) {
            return of([]);
        }

        return this.store.select(ChatBotChainsSelectors.selectChatBotChains(messenger, chatBotId)).pipe(
            mergeMap((chatBotChains: ChatBotChainEntity[]) => {
                if (!chatBotChains) {
                    this.loadChatBotChainsCollection(messenger, chatBotId);
                    return of(undefined);
                }

                return of(chatBotChains || undefined);
            })
        );
    }

    public chatBotChainsStatuses$(messenger: string, chatBotId: string): Observable<CollectionQueryStateStatuses> {
        if (!messenger || !chatBotId) {
            return of({} as any);
        }

        return this.store.select(ChatBotChainsSelectors.selectChatBotChainsStatuses(messenger, chatBotId));
    }
}
